import SafeImage from '@/components/SafeImage';

export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <SafeImage
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20amber%20and%20gold%20light%20rays%20radiating%20from%20center%2C%20film%20grain%20texture%2C%20soft%20bokeh%20effects%2C%20elegant%20theater%20curtain%20drapes%20in%20deep%20charcoal%20tones%2C%20luxurious%20cinema%20atmosphere%2C%20no%20text%2C%20abstract%20geometric%20light%20patterns%2C%20high%20contrast%20dramatic%20lighting%2C%20premium%20movie%20theater%20vibe&width=1800&height=900&seq=hero-bg-2026-n1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm font-medium tracking-wide mb-4 md:mb-5 whitespace-nowrap">
              牛牛极清
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-background-50 leading-tight mb-4 md:mb-5">
              牛牛影视 · 超清不缓冲流畅追剧平台
            </h1>

            <p className="text-base md:text-lg text-background-50/80 font-medium mb-6 md:mb-7">
              告别卡顿，沉浸式观影体验
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl lg:max-w-none mb-7 md:mb-9">
              牛牛影视汇聚海量高清电影与电视剧全集，依托牛牛超清技术与智能加速引擎，实现极清画质下零缓冲流畅播放。无论热门新片还是经典老剧，打开即看，全程不卡顿，为你打造影院级的免费在线追剧体验。每日更新片库，热门话题实时追踪，让每一次观影都成为一种享受。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8 md:mb-10">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-400">10万+</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-0.5">影视资源</div>
              </div>
              <div className="w-px h-8 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-400">4K</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-0.5">超清画质</div>
              </div>
              <div className="w-px h-8 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-400">0</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-0.5">缓冲等待</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm md:text-base whitespace-nowrap cursor-pointer transition-all duration-200 text-center"
              >
                开始追剧
              </a>
              <a
                href="#features"
                onClick={(e) => handleScrollTo(e, '#features')}
                className="w-full sm:w-auto px-8 py-3 rounded-full border border-background-50/30 hover:border-background-50/60 text-background-50 font-medium text-sm md:text-base whitespace-nowrap cursor-pointer transition-all duration-200 text-center"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[420px] lg:max-w-[480px] shrink-0">
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
              <SafeImage
                src="https://readdy.ai/api/search-image?query=A%20stunning%20cinematic%20visual%20composition%20featuring%20a%20vintage%20film%20projector%20casting%20warm%20golden%20light%20beams%20through%20atmospheric%20haze%2C%20floating%20film%20strips%20with%20abstract%20movie%20scene%20silhouettes%2C%20rich%20amber%20and%20deep%20charcoal%20color%20palette%2C%20dramatic%20theatrical%20lighting%2C%20premium%20cinema%20aesthetic%2C%20elegant%20composition%2C%20no%20text%20or%20logos%2C%20artistic%20movie%20poster%20style&width=960&height=1200&seq=hero-visual-2026-n1&orientation=portrait"
                alt="牛牛影视极清观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}